










































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { truncateText, transparentPng1x1 } from '@/utils/common'

@Component
export default class GuiaTissOpme extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get hospitalRemoveParticularDaGuiaTiss() {
    return this.getBackofficeGlobalStore.guiaTissInternacaoOpme.hospitalRemoveParticularDaGuiaTiss
  }

  get opmesComParticularesRemovidas() {
    const guias = this.getBackofficeGlobalStore.guiaTissGroupedByOpme

    if (!this.hospitalRemoveParticularDaGuiaTiss) {
      return guias
    }

    return guias.map((guia: any) => ({
      ...guia,
      grupoOpmeDaSolicitacao: guia.grupoOpmeDaSolicitacao.map((grupo: any) => ({
        ...grupo,
        opmes: grupo.opmes.filter((opme: any) => opme.particular !== 'Sim'),
      })),
    }))
  }

  get guiaTissGroupedByOpme() {
    return this.opmesComParticularesRemovidas.map((guia: any) => ({
      ...guia,
      grupoOpmeDaSolicitacao: guia.grupoOpmeDaSolicitacao.map((grupo: any) => ({
        ...grupo,
        opmesVisiveis: grupo.opmes || [],
      })),
    }))
  }

  assinatura(signature: string | null | undefined) {
    return `data:image/png;base64,${signature || transparentPng1x1()}`
  }

  montarObservacaoFornecedores(guiaTiss: any) {
    const opmes = (guiaTiss.grupoOpmeDaSolicitacao || []).flatMap((grupo: any) => grupo.opmesVisiveis || grupo.opmes || [])

    return opmes.map((opme: any) => {
      const fornecedores = ['fornecedor1', 'fornecedor2', 'fornecedor3']
        .map((chave, index) => (opme[chave] && opme[chave].nome ? `${guiaTiss.rotuloFornecedor} ${index + 1}: ${opme[chave].nome}` : null))
        .filter(Boolean)
        .join(' /')

      return `OPME: ${opme.descricao}${fornecedores ? ` - ${fornecedores}` : ''}.`
    }).join('\n')
  }


  maskText(sentence: string, limit: number = 9999) {
    if (['', null, undefined].includes(sentence)) return ''
    return truncateText(sentence, limit)
  }

  maskDateTime(date: any) {
    const formatter = new Intl.DateTimeFormat('pt-BR', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'America/Sao_Paulo',
    })
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskDate(date: any) {
    const formatter = new Intl.DateTimeFormat('pt-BR')
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskMoney(value: any) {
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    return [undefined, null, '', 0].includes(value)
      ? ''
      : formatter.format(Number(value))
  }
}
